import { motion } from "framer-motion";
import { Overline } from "@/components/Bits";

const easing = [0.16, 1, 0.3, 1];

export default function PageHero({ overline, title, subtitle, align = "left" }) {
  const center = align === "center";
  return (
    <section className={`relative pt-40 md:pt-48 pb-16 md:pb-24 border-b border-gold-500/15 overflow-hidden`} data-testid="page-hero">
      <div className="pointer-events-none absolute -top-40 right-0 h-[520px] w-[520px] rounded-full bg-ink-royal/40 blur-[120px]" />
      <div className={`relative mx-auto max-w-[1400px] px-6 md:px-10 ${center ? "text-center flex flex-col items-center" : ""}`}>
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: easing }}>
          <Overline>{overline}</Overline>
        </motion.div>
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.1, ease: easing }}
          className="mt-6 font-serif leading-[0.92] text-white text-5xl md:text-7xl lg:text-8xl tracking-tight max-w-5xl"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.25, ease: easing }}
            className={`mt-8 text-base md:text-lg text-white/70 leading-relaxed ${center ? "max-w-2xl" : "max-w-2xl"}`}
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
